(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var bar = document.getElementById('stox-announcement-bar');
  if (!bar || bar.dataset.hideOnScroll !== 'true') return;

  var lastY = 0;
  var ticking = false;

  window.addEventListener('scroll', function () {
    lastY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (lastY > 100) {
          bar.classList.add('stox-annbar--hidden');
        } else {
          bar.classList.remove('stox-annbar--hidden');
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Mobile menu ──────────────────────────────────────────────── */
  var burger     = document.querySelector('.stox-burger');
  var mobileMenu = document.getElementById('stox-mobile-menu');
  var overlay    = document.getElementById('stox-overlay');
  var closeBtn   = document.getElementById('stox-menu-close');

  function resetDrill() {
    var levels = document.getElementById('stox-mobile-levels');
    if (levels) levels.classList.remove('is-drilled');
    document.querySelectorAll('.stox-mobile-l2').forEach(function (p) {
      p.classList.remove('is-active');
      p.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.stox-mobile-l1__drill').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    /* Ferme aussi les accordéons L3 */
    document.querySelectorAll('.stox-mobile-l3__toggle').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.stox-mobile-l3__drawer').forEach(function (d) {
      d.classList.remove('is-open');
    });
  }

  function openMenu() {
    if (!mobileMenu || !overlay || !burger) return;
    overlay.style.display = 'block';
    requestAnimationFrame(function () {
      overlay.classList.add('stox-overlay--visible');
      mobileMenu.classList.add('stox-mobile-menu--open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeMenu() {
    if (!mobileMenu || !overlay || !burger) return;
    mobileMenu.classList.remove('stox-mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('stox-overlay--visible');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    resetDrill();
    setTimeout(function () {
      if (!overlay.classList.contains('stox-overlay--visible')) {
        overlay.style.display = 'none';
      }
    }, 360);
  }

  if (burger) burger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  /* ── Mobile drill-down ────────────────────────────────────────── */
  document.querySelectorAll('.stox-mobile-l1__drill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-drill');
      var l2 = document.getElementById('stox-mobile-l2-' + id);
      var levels = document.getElementById('stox-mobile-levels');
      if (!l2 || !levels) return;
      document.querySelectorAll('.stox-mobile-l2').forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
      levels.classList.add('is-drilled');
      l2.classList.add('is-active');
      l2.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
    });
  });

  document.querySelectorAll('.stox-mobile-l2__back').forEach(function (btn) {
    btn.addEventListener('click', resetDrill);
  });

  /* ── Mobile accordéons L3 ─────────────────────────────────────── */
  document.querySelectorAll('.stox-mobile-l3__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.stox-mobile-l3-wrap');
      if (!wrap) return;
      var drawer = wrap.querySelector('.stox-mobile-l3__drawer');
      if (!drawer) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      drawer.classList.toggle('is-open', !isOpen);
    });
  });

  /* ── Desktop mega menu ────────────────────────────────────────── */
  var activeMega = null;
  var megaTimer  = null;

  function openMega(id) {
    if (activeMega === id) return;
    closeMegaNow();
    activeMega = id;
    var panel   = document.getElementById('stox-mega-' + id);
    var trigger = document.querySelector('[data-mega-trigger="' + id + '"]');
    if (panel)   { panel.classList.add('stox-mega--open'); panel.setAttribute('aria-hidden', 'false'); }
    if (trigger) { trigger.setAttribute('aria-expanded', 'true'); }
  }

  function closeMegaNow() {
    if (!activeMega) return;
    var panel   = document.getElementById('stox-mega-' + activeMega);
    var trigger = document.querySelector('[data-mega-trigger="' + activeMega + '"]');
    if (panel)   { panel.classList.remove('stox-mega--open'); panel.setAttribute('aria-hidden', 'true'); }
    if (trigger) { trigger.setAttribute('aria-expanded', 'false'); }
    activeMega = null;
  }

  function scheduleMegaClose() {
    megaTimer = setTimeout(closeMegaNow, 150);
  }

  function cancelMegaClose() {
    if (megaTimer) clearTimeout(megaTimer);
  }

  document.querySelectorAll('.stox-nav__item--has-mega').forEach(function (item) {
    var id = item.getAttribute('data-mega');
    var trigger = item.querySelector('[data-mega-trigger]');

    item.addEventListener('mouseenter', function () {
      cancelMegaClose();
      openMega(id);
    });

    item.addEventListener('mouseleave', function () {
      scheduleMegaClose();
    });

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (activeMega === id) {
          closeMegaNow();
        } else {
          openMega(id);
        }
      });
    }
  });

  document.querySelectorAll('.stox-mega').forEach(function (panel) {
    panel.addEventListener('mouseenter', cancelMegaClose);
    panel.addEventListener('mouseleave', scheduleMegaClose);
  });

  document.addEventListener('click', function (e) {
    if (!activeMega) return;
    if (!e.target.closest('.stox-nav__item--has-mega') && !e.target.closest('.stox-mega')) {
      closeMegaNow();
    }
  });

  /* ── Keyboard ─────────────────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMegaNow();
      closeMenu();
      closeSearch();
    }
  });

  /* ── Search overlay ───────────────────────────────────────────── */
  var searchOverlay  = document.getElementById('stox-search-overlay');
  var searchOpenBtn  = document.getElementById('stox-search-open');
  var searchCloseBtn = document.getElementById('stox-search-close');
  var searchInput    = document.getElementById('stox-search-input');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('stox-search-overlay--open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('stox-search-overlay--open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }

  if (searchOpenBtn) searchOpenBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
